<template>
  <div class="examine-popup">
    <van-popup v-model="show">
      <header>
        <span v-if="currentPopType !== 'AGREE' ">*</span>
        {{ getTitle }}
      </header>
      <main>
        <van-field
          v-model="message"
          type="textarea"
          rows="4"
          maxlength="500"
          :placeholder="getPlaceholder"
          show-word-limit
        />
      </main>
      <div class="footer">
        <div class="left" @click="handleBtnClick">取消</div>
        <div class="right" @click="handleBtnClick('confirm')">确认</div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import { Popup, Field, Notify } from 'vant'
import { mapActions } from 'vuex'
export default {
  components: {
    [Popup.name]: Popup,
    [Field.name]: Field
  },
  computed: {
    getTitle () {
      return this.currentPopType === 'AGREE' ? '审批意见' : '驳回理由'
    },
    getPlaceholder () {
      return this.currentPopType === 'AGREE' ? '非必填，请填写审批通过意见' : '必填，请填写审批驳回理由'
    }
  },
  props: {
    currentPopType: {
      type: String,
      default: ''
    },
    callBack: {
      type: Function,
      default: () => {}
    }
  },
  data () {
    return {
      show: false,
      message: ''
    }
  },
  methods: {
    ...mapActions('my-examine', ['examine']),
    /**
     * @description 审批或驳回
     * @param type
     */
    handleBtnClick (type) {
      if (type === 'confirm') {
        if (this.currentPopType !== 'AGREE' && !this.message) {
          return Notify({ type: 'danger', message: '请填写审批驳回理由' })
        }
        this.callBack(this.message)
        this.show = false
      } else {
        this.show = false
      }
    }
  },
  mounted () {
  }
}
</script>
<style lang="less" scoped src="./index.less" />
